import DeleteIcon from 'assets/icons/deleteIcon.svg';
import {
  moleculeStrengthOptionsInterface,
  portfolioOpportunitiesDataInterface,
  User,
} from 'Interfaces/BDPortalInterfaces';
import { observer } from 'mobx-react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import AsyncSelect from 'react-select/async';
import { getBackgroundColor } from 'utils/avatarUtilities';
import { getInitials } from 'utils/getInitials';
import StrengthPackSizeNdcManagementModal from '../StrengthPackSizeNdcManagementModal/StrengthPackSizeNdcManagementModal';
import classes from './PortfolioDataValidationComponent.module.scss';
import useDataValidationComponent from './usePortfolioDataValidatonComponent';
import CommentsAddEditModal from '../CommentsAddEditModal/CommentsAddEditModal';
import { Nullable } from 'primereact/ts-helpers';

const DatavalidationComponent = ({
  data,
  successCallBack,
  moleculeStrengthOptionsData,
}: // view = "view",
{
  data: portfolioOpportunitiesDataInterface;
  successCallBack: () => void;
  moleculeStrengthOptionsData: moleculeStrengthOptionsInterface[];
  // view?: "view" | "edit";
}) => {
  const {
    bulkUpdateData,
    isBulkUpdating,
    checkIfThereAreErrors,
    handleVerify,
    handleRowDeleteButtonClick,
    getErrorDescription,
    getAssigneedOptions,
    dropdownDetails,
    inputOperations,
    checkIfVerifyDataButtonIsDiabled,
    areAllRowsSelected,
    handleRowSelectUnselect,
    handleCheckIfRowIsSelected,
    handleSelectAll,
    fetchSuggestionsWithDelay,
    opportunityTypeOptions,
    fetchSuggestionsWithDelayForSuppliers,
    handleClickRowOpenCloseStrengthCommentAccordion,
    checkIfRowAccordionStrengthAccordionOpen,
    getRowStrengthOptions,
    checkIfStrengthsLoadingForRow,
  } = useDataValidationComponent({
    data,
    successCallBack,
    moleculeStrengthOptionsData,
  });

  const assigneeOptionTemplate = (option: User | null) => {
    return (
      <>
        {option ? (
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            {option.ID > 0 && (
              <Avatar
                title={option.Name}
                id="profileAvatar"
                shape="circle"
                label={option.Name && getInitials(option?.Name)}
                style={{
                  backgroundColor: getBackgroundColor(option.Name[0]),
                  color: '#522D6E',
                  marginRight: '0.5rem',
                  width: '1.6rem',
                  height: '1.6rem',
                }}
              />
            )}
            <div>{option.Name}</div>
          </div>
        ) : (
          <span>Unassigned</span>
        )}
      </>
    );
  };

  return (
    <div className={classes.DataValidationComponentcontainer}>
      <>
        <div className={classes.sourceSupplierSelectorDivWrapper}>
          <div className={classes.sourceSection}>
            <span>Source : </span>
            <Dropdown
              options={dropdownDetails?.NC.Source}
              // optionLabel="name"
              value={inputOperations.source.value()}
              optionLabel="Source"
              optionValue="ID"
              onChange={e => inputOperations.source.onChange(e.value)}
              placeholder="Select Source"
              // className={styles.selectDropdown}
              style={{
                margin: '0.5rem 0',
                marginRight: '0.25rem',
                border: '1px solid #00000020',
                flexGrow: 1,
              }}
            />
          </div>
          <div className={classes.supplier}>
            <span>Supplier : </span>
            <AsyncSelect
              loadOptions={fetchSuggestionsWithDelayForSuppliers}
              // onInputChange={}
              onChange={option => {
                inputOperations.suppier.onChange(option?.value || '');
              }}
              defaultOptions
              placeholder="Search..."
              value={
                inputOperations.suppier.value()
                  ? {
                      label: inputOperations.suppier.value(),
                      value: inputOperations.suppier.value(),
                    }
                  : null
              }
              // className="w-full"
              className="supplier-select-portfolio-opportunity"
            />
          </div>
        </div>
        <div className={classes.tableWrapper}>
          <div
            className={classes.dataTable}
            style={{
              maxHeight: '60vh !important',
            }}
          >
            <div className={classes.tableHeading}>
              <div className={classes.tableHeadingCheckBox}>
                <Checkbox
                  disabled={isBulkUpdating}
                  onClick={handleSelectAll}
                  className={classes.rowSelectCheckBox}
                  checked={areAllRowsSelected()}
                  style={{
                    boxShadow: 'white 0px 1px 4px',
                  }}
                />
              </div>
              <div className={classes.tableHeadingOpportunityType}>Opportunity Type</div>
              <div className={classes.tableHeadingMolecule}>Molecule</div>
              <div className={classes.tableHeadingAnalyst}>Analyst</div>
              {checkIfThereAreErrors() && <div className={classes.errorsTh}>Errors</div>}
              <div className={classes.tableHeadingDelete}>Delete</div>
            </div>
            <div
              className="bulkUpdateTable"
              style={{
                maxHeight: '65vh !important',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
              }}
            >
              {bulkUpdateData.map((data, index) => {
                return (
                  <div key={index}>
                    <div className={classes.tableRow} key={'dataValidation' + index}>
                      <div className={classes.tableHeadingCheckBox}>
                        <span className={classes.rowCounter}>{index + 1}.</span>
                        <Checkbox
                          onClick={() => handleRowSelectUnselect(index)}
                          className={classes.rowSelectCheckBox}
                          checked={handleCheckIfRowIsSelected(index)}
                          disabled={isBulkUpdating}
                        />
                      </div>

                      <div className={classes.tableHeadingOpportunityType}>
                        <Dropdown
                          value={inputOperations.opportunityType.value(index)}
                          onChange={e => {
                            inputOperations.opportunityType.onChange(index, e.target.value.name);
                          }}
                          options={opportunityTypeOptions}
                          optionLabel="name"
                          placeholder="Select COT"
                          panelStyle={{
                            padding: '0.0rem 0.5rem',
                            color: 'red',
                          }}
                          style={{
                            width: '9rem',
                            maxWidth: '9rem',
                            // padding: "0.0rem 0.7rem",
                            // maxHeight: "2rem",
                          }}
                        />
                      </div>

                      <div className={classes.tableHeadingMolecule}>
                        <AsyncSelect
                          loadOptions={fetchSuggestionsWithDelay}
                          onChange={option => {
                            inputOperations.molecule.onChange(index, option?.value || '');
                          }}
                          maxMenuHeight={200}
                          defaultOptions
                          placeholder="Search..."
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({
                              ...provided,
                              zIndex: 1000,
                              position: 'absolute',
                            }),
                          }}
                          value={
                            inputOperations.molecule.value(index)
                              ? {
                                  label: inputOperations.molecule.value(index),
                                  value: inputOperations.molecule.value(index),
                                }
                              : null
                          }
                          // isDisabled={addOppLoading}
                        />
                      </div>

                      <div className={classes.tableHeadingAnalyst}>
                        <Dropdown
                          itemTemplate={assigneeOptionTemplate}
                          valueTemplate={assigneeOptionTemplate}
                          value={inputOperations.analyst.value(index)}
                          onChange={e => {
                            inputOperations.analyst.onChange(index, e.target.value);
                          }}
                          options={getAssigneedOptions()}
                          optionLabel="Name"
                          optionValue="ID"
                          className="bdportal p-1 border"
                          placeholder="Select Analyst"
                          style={{
                            // width: "15rem",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        />
                      </div>
                      {checkIfThereAreErrors() && (
                        <div className={classes.errorsTh}>
                          <div className={classes.errorDescription}>
                            {getErrorDescription(index)}
                          </div>
                        </div>
                      )}

                      <div className={classes.tableHeadingDelete}>
                        <img
                          className={classes.deleteIcon}
                          src={DeleteIcon}
                          alt="Delete"
                          style={{
                            width: '1.1rem',
                          }}
                          onClick={() => handleRowDeleteButtonClick(index)}
                        />
                        <span
                          style={
                            !checkIfRowAccordionStrengthAccordionOpen(index)
                              ? {
                                  rotate: '90deg',
                                  marginLeft: '0.5rem',
                                  transitionDuration: '0.5s',
                                }
                              : {
                                  display: 'flex',
                                  marginLeft: '0.5rem',
                                  transitionDuration: '0.5s',
                                }
                          }
                          onClick={() => handleClickRowOpenCloseStrengthCommentAccordion(index)}
                        >
                          ►
                        </span>
                      </div>
                    </div>
                    <div
                      className={classes.strengthPacksizeCommentsAccordion}
                      style={
                        checkIfRowAccordionStrengthAccordionOpen(index)
                          ? {
                              maxHeight: '400px',
                              height: `${
                                2.7 * inputOperations.strengthNdcPacksize.value(index).length + 2.3
                              }rem`,
                              transitionDuration: '0.3s',
                              display: 'flex',
                              overflow: 'hidden',
                              padding: '1rem',
                            }
                          : {
                              height: 0,
                              overflow: 'hidden',
                              padding: '0',
                              transitionDuration: '0.3s',
                            }
                      }
                    >
                      <StrengthPackSizeNdcManagementModal
                        key={
                          inputOperations.molecule.value(index) +
                          inputOperations.strengthNdcPacksize.value(index) +
                          index
                        }
                        value={inputOperations.strengthNdcPacksize.value(index)}
                        moleculeName={inputOperations.molecule.value(index)}
                        handleValueChange={value => {
                          inputOperations.strengthNdcPacksize.onChange(index, value);
                          // toast.success("Saved successfully.");
                        }}
                        rowIndex={index}
                        strengthOptions={getRowStrengthOptions(index)}
                        strengthOptionsLoading={checkIfStrengthsLoadingForRow(index)}
                      />
                      <CommentsAddEditModal
                        value={inputOperations.comments.value(index)}
                        handleValueChange={(value: Nullable<string[]>) =>
                          inputOperations.comments.onChange(index, value)
                        }
                        limitReached={inputOperations.comments.disabled(index)}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <Button
          className={classes.createButton}
          onClick={handleVerify}
          loading={isBulkUpdating}
          disabled={checkIfVerifyDataButtonIsDiabled()}
        >
          Create
        </Button>
      </>
    </div>
  );
};

export default observer(DatavalidationComponent);
